module.exports = __webpack_public_path__ + "../resources/img/ic_rain_hail_weather.70c90d0d.svg";